module.exports = __webpack_public_path__ + "static/media/logo-u.749ed6fb.svg";